module.exports = __webpack_public_path__ + "static/media/icono-cerrar.84dcb6e2.svg";